module.exports = __webpack_public_path__ + "MOEDC-14b7dd93f66884dfe6107175b2156f62.png";